import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { Wrapper } from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Styles/style'

const CollegeTierFilter = ({ collegeTierValue, setCollegeTierValue }) => {
  const tierOptions = [
    {
      label: 'Tier 1',
      value: '1',
    },
    {
      label: 'Tier 2',
      value: '2',
    },
    {
      label: 'Tier 3',
      value: '3',
    },
    {
      label: 'Tier 4',
      value: '4',
    },
  ]
  return (
    <Wrapper column>
      <FilterCheckBoxComp
        value={collegeTierValue}
        options={tierOptions}
        onChange={values => setCollegeTierValue([values[values?.length - 1]])}
      />
    </Wrapper>
  )
}

export default CollegeTierFilter
